import styled, { keyframes } from 'styled-components';

// Bottom navigation — visivel SO em <=720px (phone). Acima disso o
// SideMenu rail assume. Barra fixa no rodape, touch-first (tap, sem
// hover). Padrao app mobile: 4 slots (3 itens principais + "Mais").

export const Bar = styled.nav`
  display: none;

  @media (max-width: 720px) {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 50;
    align-items: stretch;
    justify-content: space-around;
    height: 58px;
    /* respeita a safe-area (notch/home-indicator do iOS) */
    padding-bottom: env(safe-area-inset-bottom, 0px);
    background: var(--cco-bg);
    border-top: 1px solid var(--cco-line);
    box-shadow: 0 -2px 12px
      ${(props) =>
        props.theme.title === 'light'
          ? 'rgba(15, 23, 42, 0.08)'
          : 'rgba(0, 0, 0, 0.4)'};
  }
`;

export const Item = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 6px 2px;
  position: relative;
  text-transform: none;
  font-family: inherit;
  color: ${(props) =>
    props.$active ? 'var(--cco-blue)' : 'var(--cco-ink-mute)'};
  transition: color 0.15s;
  /* alvo de toque confortavel (>=44px de altura efetiva) */
  min-height: 44px;

  > svg {
    width: 22px;
    height: 22px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  > .lbl {
    font-size: var(--fs-caption);
    font-weight: 600;
    letter-spacing: 0.01em;
    line-height: 1;
  }

  &:active {
    color: var(--cco-blue);
  }
`;

// Indicador do item ativo — barrinha no topo do slot (estilo material).
export const ActiveBar = styled.span`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 28px;
  height: 3px;
  border-radius: 0 0 3px 3px;
  background: var(--cco-blue);
`;

export const Badge = styled.span`
  position: absolute;
  top: 4px;
  left: calc(50% + 8px);
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--cco-red);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: grid;
  place-items: center;
  line-height: 1;
  box-shadow: 0 0 0 2px var(--cco-bg);
`;

// ── Folha "Mais" (bottom sheet) ───────────────────────────────────
const slideUp = keyframes`
  from { transform: translateY(100%); }
  to   { transform: translateY(0); }
`;

export const SheetBackdrop = styled.div`
  display: none;
  @media (max-width: 720px) {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 60;
    background: rgba(0, 0, 0, 0.45);
  }
`;

export const Sheet = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 61;
  background: var(--cco-bg);
  border-top: 1px solid var(--cco-line);
  border-radius: 16px 16px 0 0;
  padding: 8px 8px calc(12px + env(safe-area-inset-bottom, 0px));
  box-shadow: 0 -8px 28px rgba(0, 0, 0, 0.4);
  animation: ${slideUp} 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  max-height: 70vh;
  overflow-y: auto;

  > .grabber {
    width: 36px;
    height: 4px;
    border-radius: 999px;
    background: var(--cco-line-strong);
    margin: 6px auto 10px;
  }
`;

export const SheetItem = styled.button`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 13px 14px;
  background: transparent;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  text-transform: none;
  font-family: inherit;
  font-size: var(--fs-body);
  font-weight: 600;
  color: ${(props) =>
    props.$active ? 'var(--cco-blue)' : 'var(--cco-ink)'};

  > svg {
    width: 22px;
    height: 22px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    flex-shrink: 0;
  }

  &:active {
    background: ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0, 0, 0, 0.04)'
        : 'rgba(255, 255, 255, 0.05)'};
  }

  &.danger {
    color: var(--cco-red);
  }
`;
